import React, { FC } from 'react';
import { TypeImage } from '@/core/generated-types';
import NextImage from 'next/image';
import { Asset } from 'contentful';
import classNames from 'classnames';

interface ImageProps {
  imageData?: TypeImage | undefined;
  className?: string;
  width?: number;
  height?: number;
  alt?: string;
  altText?: string;
  Image?: Asset;
  entryName?: string;
  loading?: 'lazy' | 'eager';
}

const _formatImageUrl = (url: string | undefined) => {
  if (!url) {
    return 'https://placehold.co/600x400/png';
  }

  if (url.startsWith('//')) {
    return `https:${url}`;
  }

  // URL starts with http, https, or is relative
  return url;
};

const LuvImage: FC<ImageProps> = ({
  imageData,
  entryName,
  Image,
  altText,
  loading = 'lazy',
  className = 'mx-auto',
  width = Image?.fields?.file?.details?.image?.width ?? 200,
  height = Image?.fields?.file?.details?.image?.height ?? 200,
}) => {
  const imageObj = imageData ? imageData.fields : { entryName, Image, altText };

  return (
    imageObj && (
      <>
        <NextImage
          data-testid={`image_${imageObj.entryName}`}
          alt={imageObj?.altText || ''}
          src={_formatImageUrl(imageObj.Image?.fields?.file?.url)}
          className={classNames(className)}
          width={width}
          height={height}
          loading={loading}
        />
      </>
    )
  );
};

export default React.memo(LuvImage);
